import { o2oApi } from 'yxt-biz-pc/packages/api';

export const getPlanCompare = (formId) => {
  return o2oApi.get(`plan/compare/info?formId=${formId}`);
};

export const getPlanAuditCompare = (formId) => {
  return o2oApi.get(`plan/audit/compare/info?formId=${formId}`);
};

// 下载文件
export const putThirdUrl = fileId => {
  return o2oApi.put(`third/file/${fileId}`);
};
